import { render, staticRenderFns } from "./AddProjectStep3House.vue?vue&type=template&id=24ed7638&"
import script from "./AddProjectStep3House.vue?vue&type=script&lang=js&"
export * from "./AddProjectStep3House.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports